import {
  DateTimeSchema,
  objectIdRef,
  ObjectIdSchema,
  ObjectIdString,
  SavableOpportunityFilters,
} from '../common.js';
import z from 'zod';
import { RelatedEntityMetadata } from '../../interfaces.js';
import { DayOfWeek } from '../common.js';

export { DayOfWeek };

export const GroupOpportunitiesBy = z.enum(['owner', 'type']);
export type GroupOpportunitiesBy = z.infer<typeof GroupOpportunitiesBy>;

export const EmailFrequency = z.enum(['scheduled', 'real-time']);
export type EmailFrequency = z.infer<typeof EmailFrequency>;

export const SAVED_SEARCH_TIME_FORMAT = 'HH:mm';

export const EmailAlertSettings = z.object({
  groupBy: GroupOpportunitiesBy,
  emailFrequency: EmailFrequency,
  scheduleTime: z.iso.time({ precision: -1 }).describe(`Format: ${SAVED_SEARCH_TIME_FORMAT}`),
  // TODO: maybe just grab the time zone from the user instead (https://github.com/Toro-Translate/toro-monorepo/issues/690)
  timezone: z.string().describe('Locale name, e.g. "America/New_York"'),
  selectedDays: DayOfWeek.array(),
  sendEmptyAlerts: z.boolean(),
});
export type EmailAlertSettings = z.infer<typeof EmailAlertSettings>;

export const SavedSearchStatus = z.enum(['active', 'deleted']);

export const ISavedSearch = z.object({
  _id: ObjectIdSchema,
  status: SavedSearchStatus.default('active'),
  type: z.literal('staffIq').default('staffIq'),
  account: objectIdRef('Account'),
  user: objectIdRef('AuthUser'),
  searchName: z.string(),
  filters: SavableOpportunityFilters,
  emailAlertsEnabled: z.boolean(),
  emailSettings: EmailAlertSettings,
  createdAt: DateTimeSchema,
  updatedAt: DateTimeSchema,

  metadata: z.object({
    relatedEntities: z.map(z.enum(['emailAlertSearch']), RelatedEntityMetadata),
  }),
});
export type ISavedSearch = z.infer<typeof ISavedSearch>;

export const SavedSearchDTO = z.object({
  ...ISavedSearch.shape,
  _id: ObjectIdString,
  metadata: ISavedSearch.shape.metadata.optional(), // Make optional in DTO
});
export type SavedSearchDTO = z.infer<typeof SavedSearchDTO>;

export const SavedSearchInput = SavedSearchDTO.partial({
  _id: true,
  user: true,
  account: true,
  type: true,
  createdAt: true,
  updatedAt: true,
  metadata: true,
});
export type SavedSearchInput = z.infer<typeof SavedSearchInput>;
